import { Component, OnInit } from '@angular/core';
import { config } from '../../../config.prod';

@Component({
  selector: 'ngx-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.scss']
})
export class HelpComponent implements OnInit {
  // config = config;
  constructor() { }

  ngOnInit() {
  }

}
